import {Injectable} from '@angular/core';
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class MobileOfflineQueueService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/ct/mobileOfflineQueues')
    }

    getObjectIcon(): string {
        return 'fa-solid fa-list-check';
    }

    /**
     * Gets queue items for a session.
     */
    getBySession(sessionId: number): Observable<any[]> {
        return this.http.get<any[]>(`${this.apiUrl}/by-session/${sessionId}`);
    }

    /**
     * Gets pending items for a session.
     */
    getPendingBySession(sessionId: number): Observable<any[]> {
        return this.http.get<any[]>(`${this.apiUrl}/by-session/${sessionId}/pending`);
    }

    /**
     * Gets all pending items.
     */
    getAllPending(): Observable<any[]> {
        return this.http.get<any[]>(`${this.apiUrl}/pending`);
    }

    /**
     * Gets failed items for retry.
     */
    getFailedForRetry(): Observable<any[]> {
        return this.http.get<any[]>(`${this.apiUrl}/failed-for-retry`);
    }
}
